"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseGroupChats = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const utils_1 = require("../../utils");
const CollectionUtils_1 = require("../../utils/CollectionUtils");
class BaseGroupChats {
    constructor(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage) {
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
    }
    buildFetchChatsRequest(groupType) {
        const chatList = this.getChatsStorage().getChatListByType(groupType);
        const isHiddenGroup = groupType === models_1.GROUP_TYPE.HIDDEN;
        const request = Object.assign(Object.assign(Object.assign({ chatType: models_1.CHAT_TYPE.GROUP }, (!isHiddenGroup && { groupType })), (isHiddenGroup && { hiddenChats: true })), { limit: utils_1.HHNConstants.PAGINATION_LIMIT, total: chatList && chatList.chats.length > 0 ? chatList.chats.length : 0 });
        return request;
    }
    fetchGroupChatList(chatRequestBody, groupType, requestFilters, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatListResponse = yield this.httpAdapter
                .getChatAdapter()
                .getGroupChatList(chatRequestBody, context);
            if (!chatListResponse.isAborted) {
                const filteredChatListResponse = chatListResponse.data.data.filter(chatList => chatList.status !== models_1.CHAT_STATUS.DELETED);
                const newChats = (0, mappers_1.groupChatsMapper)(Object.assign(Object.assign({}, chatListResponse.data), { data: filteredChatListResponse }), this.userDirectory, this.organizationUser, this.httpAdapter);
                this.populateChatList(newChats, groupType, "APPEND", (_, newChats) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { chats, chatFilters } = newChats, restData = __rest(newChats, ["chats", "chatFilters"]);
                    return Object.assign({}, restData);
                }, false, requestFilters);
            }
        });
    }
    populateChatList(newChats, groupType, order, mergeHandler, showMergedChatsOnTop, chatFilters) {
        let chatList = this.getChatsStorage().getChatListByType(groupType);
        const nonDeletedChats = Object.assign(Object.assign({}, newChats), { chats: newChats.chats.filter(c => c.status !== models_1.CHAT_STATUS.DELETED) });
        const { mergedItems } = (0, CollectionUtils_1.mergeAppendToArray)(chatList.chats, nonDeletedChats.chats, c => c.id, order, showMergedChatsOnTop);
        if (chatList) {
            const mergedData = mergeHandler(chatList, nonDeletedChats);
            console.warn(`[DEBUG unreadCount] populateChatList | ${groupType} | existing: ${chatList.unreadChatCount} | server/merged: ${mergedData.unreadChatCount} | existingChats: ${chatList.chats.length} | newChats: ${nonDeletedChats.chats.length} | mergedChats: ${mergedItems.length} | chatsWithUnread: ${mergedItems.filter(c => c.unreadCount > 0).length}`);
            chatList = Object.assign(Object.assign(Object.assign({}, mergedData), { chats: mergedItems }), (chatFilters && { chatFilters }));
        }
        this.getChatsStorage().setChatListByType(groupType, chatList);
    }
}
exports.BaseGroupChats = BaseGroupChats;
